
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11zm-.125-14.45a1.125 1.125 0 100-2.25 1.125 1.125 0 000 2.25zm-.625 1a.75.75 0 000 1.5h.25v4.3h-.75a.75.75 0 000 1.5h3a.75.75 0 000-1.5H13V10.3a.75.75 0 00-.75-.75h-1z","fill":"#fff"}})])
          )
        }
      }
    